<template lang="pug">
  .kpi
    .kpi__title
      span {{ $t('KPI名称') }}
      span {{ $t('量化指标') }}
      span {{ $t('占比') }}
    .kpi__item(
      v-for="item, index in kpi"
      :key="index"
      style="margin-bottom: 5px"
    )
      el-select(
        v-if="item.kpi_type === ORIGINAL_KPI_TYPE"
        :placeholder="$t('选择KPI')"
        v-model="item.kpi_id",
        @change="changeKpi(item, index)"
      )
        el-option(
          v-for="k, i in kpiList"
          :key="i"
          :label="$t(k.kpi_name)"
          :value="k.kpi_id"
          :disabled="kpi.some(kpi => kpi.kpi_id === k.kpi_id)"
        )
        el-button(
          type="text"
          style="padding: 10px 20px"
          @click="selectKpi(index)"
        ) + {{ $t('自定义KPI') }}
      el-input(
        v-else
        style="width: 180px; margin-right: 5px"
        v-model="item.kpi_name"
      )
      .kpi__item__target
        input-with-commas(
          v-model="item.target"
          placeholder="量化指标"
          @change="$emit('change', kpi)"
          @blur="calcValidateTargetArray"
          :isValidate="validateTargetArray[index] !== ''"
          :unit="calcUnit(item)"
        )
        span(v-if="validateTargetArray[index] !== ''") {{ $t(validateTargetArray[index]) }}
      .kpi__item__percent
        el-input(
          v-model="item.kpi_percent"
          :placeholder="$t('占比')"
          @change="changePercent"
          @blur="calcValidatePercentArray"
          :class="{ invalid: validatePercentArray[index] !== '' }"
        )
          span(slot="suffix") %
        span(v-if="validatePercentArray[index] !== ''") {{ $t(validatePercentArray[index]) }}
      el-button(
        icon="el-icon-delete"
        circle
        style="margin-left: 5px"
        @click="delKpi(index)")
    el-button(
      @click="addKpi"
      type="primary"
    ) +{{ $t('添加KPI') }}
    span(:style="{ display: 'inline-block', width: '485px', textAlign: 'right' }")
      span(
      ) {{ $t('总占比') }}: {{ totalPercent }}%
      span(
        v-if="totalPercent !== 100"
        style="color: #f56c6c; margin-left: 10px"
      ) ({{ $t('KPI目标总占比之和需为100%') }})
    el-dialog(
      :title="$t('自定义KPI')"
      :visible.sync="showDialog"
      :close-on-click-modal="false"
      @close="onClose"
      center
    )
      el-row.row-content(
        :gutter="20"
        style="margin-top: 0; display: flex; justify-content: center"
      )
        el-col.required(:span="4") {{ $t('KPI名称') }}
        el-col(:span="10")
          el-input(
            v-model="dialogData.name"
            style="width: 180px"
            :maxlength="100"
            :placeholder="$t('≤100字')"
          )
      el-row.row-content(
        :gutter="20"
        style="display: flex; justify-content: center"
      )
        el-col.required(:span="4") {{ $t('单位') }}
        el-col(:span="10")
          el-input(
            v-model="dialogData.unit"
            style="width: 180px"
            :maxlength="100"
            :placeholder="$t('≤100字')"
          )
      div(style="text-align:center")
        footer-button(
          @confirm="confirmDialog"
          @cancel="cancelDialog"
        )
</template>

<script>
import axios from 'axios'
import { KPIMap, checkFix2 } from '@/umcc/constant.js'
import InputWithCommas from '@/components/InputWithCommas'
import FooterButton from '@/components/FooterButton'

const ORIGINAL_KPI_TYPE = 1
const CUSTOMIZED_KPI_TYPE = 2

export default {
  components: {
    InputWithCommas,
    FooterButton
  },
  model: {
    prop: 'propKpi',
    event: 'change'
  },
  props: {
    propKpi: {
      type: Array,
      default () {
        return null
      }
    }
  },
  watch: {
    propKpi () {
      this.kpi = this.propKpi
      this.calcTotalPercent()
      this.calcValidateTargetArray()
      this.calcValidatePercentArray()
    }
  },
  data () {
    return {
      showDialog: false,
      selectedKpi: null,
      KPIMap,
      CUSTOMIZED_KPI_TYPE,
      ORIGINAL_KPI_TYPE,
      kpiList: null,
      dialogData: {
        name: '',
        unit: ''
      },
      validateTargetArray: [],
      validatePercentArray: [],
      kpi: [],
      totalPercent: 0
    }
  },
  mounted () {
    if (this.propKpi.length !== 0) {
      this.kpi = this.propKpi
      this.calcTotalPercent()
    }
    this.fetchKpiList()
    this.calcValidateTargetArray()
    this.calcValidatePercentArray()
  },
  methods: {
    onClose () {
      this.dialogData = {
        name: '',
        unit: ''
      }
    },
    calcTotalPercent () {
      this.totalPercent = this.kpi.reduce((sum, item) => {
        return sum + Number(item.kpi_percent)
      }, 0) || 0
    },
    changePercent () {
      this.$emit('change', this.kpi)
      this.calcTotalPercent()
    },
    calcUnit (item) {
      if (item.kpi_type === this.ORIGINAL_KPI_TYPE) {
        if (item.kpi_id) {
          return this.kpiList ? this.kpiList.find(k => k.kpi_id === item.kpi_id).unit : ''
        } else {
          return ''
        }
      } else {
        return item.unit
      }
    },
    selectKpi (index) {
      this.selectedKpi = index
      this.showDialog = true
    },
    confirmDialog () {
      if (this.dialogData.name === '') {
        this.$message.error(this.$t('请填写KPI名称'))
        return
      }
      if (this.dialogData.unit === '') {
        this.$message.error(this.$t('请填写单位'))
        return
      }
      this.kpi[this.selectedKpi] = {
        target: '',
        kpi_id: null,
        kpi_percent: '',
        kpi_name: this.dialogData.name,
        kpi_type: 2,
        unit: this.dialogData.unit
      }
      this.$emit('change', this.kpi)
      this.showDialog = false
    },
    cancelDialog () {
      this.selectedKpi = null
      this.showDialog = false
    },
    changeKpi (item, index) {
      item.target = ''
      item.kpi_percent = ''
      this.validateTargetArray[index] = ''
      this.validatePercentArray[index] = ''
      this.calcTotalPercent()
      this.$emit('change', this.kpi)
    },
    fetchKpiList () {
      axios
        .get('/management/subfinal/getKpiList')
        .then((res) => {
          this.kpiList = res
        })
    },
    delKpi (index) {
      this.kpi.splice(index, 1)
      this.calcValidateTargetArray()
      this.calcValidatePercentArray()
      this.calcTotalPercent()
      this.$emit('change', this.kpi)
    },
    addKpi () {
      this.kpi.push({
        target: '',
        kpi_id: null,
        kpi_percent: '',
        kpi_name: '',
        kpi_type: 1
      })
      this.calcValidateTargetArray()
      this.calcValidatePercentArray()
      this.calcTotalPercent()
      this.$emit('change', this.kpi)
    },
    checkTargetValidate (kpi) {
      if (kpi.kpi_type === CUSTOMIZED_KPI_TYPE) {
        return checkFix2(kpi.target) ? '' : this.$t('最多为两位小数')
      } else {
        const kpiObject = KPIMap.find(k => k.kpiId === kpi.kpi_id)
        return kpiObject.validate(kpi.target) ? '' : kpiObject.validateMessage
      }
    },
    calcValidateTargetArray () {
      this.validateTargetArray = this.kpi.map(k => {
        return k.kpi_id == null ? k.kpi_type === CUSTOMIZED_KPI_TYPE ? this.checkTargetValidate(k) : '' : this.checkTargetValidate(k)
      })
    },
    calcValidatePercentArray () {
      this.validatePercentArray = this.kpi.map(k => {
        return this.checkPercentValidate(k)
      })
    },
    checkPercentValidate (kpi) {
      const percent = kpi.kpi_percent
      return ((Number.isInteger(Number(percent)) && Number(percent) > 0) || percent === '') ? '' : this.$t('必须为正整数')
    }
  }
}
</script>

<style lang="stylus">
.kpi
  .el-dialog
    width 550px

.kpi__title
  span
    display inline-block
    width 180px
    margin-right 5px
    text-align center

.kpi__item
  display flex
  align-items baseline
  .invalid
    > input
      border-color #f56c6c !important
  > .el-select > .el-input
      width 180px
      margin-right 5px
  > .el-input
    margin-right 5px
    > input
      width 180px

.kpi__item__percent
  > .el-input
    width 180px

.kpi__item__target
  .el-input
    width 205px

.kpi__item__target
.kpi__item__percent
  display flex
  flex-direction column
  > span
    color #f56c6c

.kpi__item__target
  .input-with-commas
    margin-right 5px
</style>
